import { DarwinRoleType } from '../../types'

export const DARWIN_ROLES: DarwinRoleType[] = ['admin', 'darwin', 'domain', 'darwin-admin']
export const REGISTRY_USER_ROLES  = [
  'operator',
  'tech',
  'legal',
  'operator-admin',
  'tech-admin',
  'legal-admin',
]